import { EvaAddress } from "./address";

export enum AddressType {
  PROJECT = "PROJECT",
  SITE = "SITE",
  INTERVENTION = "INTERVENTION",
  OTHER = "OTHER",
}

export class AdditionalAddress {
  title: string;
  address: EvaAddress;
  is_shows_in_doc: boolean;
  address_type: AddressType;
  site_name: string;
  show_site_name: boolean;

  constructor() {
    this.is_shows_in_doc = false;
    this.address_type = AddressType.SITE;
    this.address = new EvaAddress();
    this.title = "Adresse d'intervention";
    this.site_name = "";
    this.show_site_name = false;
  }

  public static createInstance(jsonData: AdditionalAddress): AdditionalAddress {
    const a = Object.assign(new AdditionalAddress(), jsonData);
    if (jsonData.address) {
      a.address = EvaAddress.createInstance(jsonData.address);
    }

    return a;
  }

  public static createInstances(jsonData: AdditionalAddress[]): AdditionalAddress[] {
    return jsonData.map(AdditionalAddress.createInstance);
  }
}
